import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Switch,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface GroupFormProps {
  group?: {
    name: string;
    description: string;
    private: boolean;
  } | null;
  onSave: (data: { name: string; description: string; private: boolean }) => void;
  onCancel: () => void;
}

export const GroupForm = ({ group, onSave, onCancel }: GroupFormProps) => {
  const { t } = useTranslation('groups');
  const [form, setForm] = useState({
    name: '',
    description: '',
    private: false
  });

  useEffect(() => {
    if (group) {
      setForm({
        name: group.name,
        description: group.description,
        private: group.private
      });
    }
  }, [group]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <DialogTitle>
        {group ? t('form.editTitle') : t('form.createTitle')}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label={t('form.name')}
          margin="normal"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
        />
        <TextField
          fullWidth
          label={t('form.description')}
          margin="normal"
          multiline
          rows={4}
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />
        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={form.private}
                onChange={(e) => setForm({ ...form, private: e.target.checked })}
              />
            }
            label={t('form.private')}
          />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {form.private ? t('form.privateHint') : t('form.publicHint')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('common:actions.cancel')}</Button>
        <Button type="submit" variant="contained">
          {group ? t('common:actions.update') : t('common:actions.create')}
        </Button>
      </DialogActions>
    </Box>
  );
};